// extracted by mini-css-extract-plugin
export var danger = "_3z-6";
export var lightPink = "_3z-a";
export var medium = "_3z-j";
export var nearSquare = "_3z-m";
export var neutralBlue = "_3z-8";
export var neutralYellow = "_3z-7";
export var noCapitalize = "_3z-1";
export var normal = "_3z-2";
export var pill = "_3z-0";
export var primary = "_3z-3";
export var primaryLight = "_3z-4";
export var shadow = "_3z-n";
export var small = "_3z-k";
export var solidBlack = "_3z-i";
export var solidGreen = "_3z-d";
export var solidLightBlue = "_3z-f";
export var solidNavy = "_3z-e";
export var solidOrange = "_3z-h";
export var solidPink = "_3z-g";
export var solidRed = "_3z-b";
export var solidWhite = "_3z-9";
export var solidYellow = "_3z-c";
export var success = "_3z-5";
export var xsmall = "_3z-l";